import { useState, useEffect } from "react";
import { KTSVG } from "../../../helpers/KTSVG";
import { useDebounce } from "../../../hooks/useDebounce";
import useTableCtx from "../tableContext/useTableCtx";
import {
  tableControlBaseClasses,
  tableControlContainerClasses,
} from "./tableControlStyles";

const TableGlobalSearch = ({
  withGlobalSearch,
}: {
  withGlobalSearch?:
    | boolean
    | {
        placeholder?: string;
        searchDelay?: number;
      };
}) => {
  const tableContext = useTableCtx()!;

  const { setTableGlobalSearch } = tableContext;

  const { placeholder, searchDelay } = withGlobalSearch as {
    placeholder?: string;
    searchDelay?: number;
  };

  const [searchTerm, setSearchTerm] = useState<string>("");
  // Debounce search term so that it only gives us latest value ...
  // ... if searchTerm has not been updated within last 500ms.
  // The goal is to only have the API call fire when user stops typing ...
  // ... so that we aren't hitting our API rapidly.
  const debouncedSearchTerm = useDebounce(searchTerm, searchDelay || 500);
  // Effect for API call
  useEffect(
    () => {
      if (debouncedSearchTerm !== undefined && searchTerm !== undefined) {
        // updateState({search: debouncedSearchTerm, ...initialQueryState})
        setTableGlobalSearch &&
          setTableGlobalSearch(debouncedSearchTerm.toString());
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [debouncedSearchTerm], // Only call effect if debounced search term changes
    // More details about useDebounce: https://usehooks.com/useDebounce/
  );

  return (
    <div className={tableControlContainerClasses}>
      {/* begin::Search */}
      <div className="relative flex items-center">
        <KTSVG
          path="/media/icons/duotune/general/gen021.svg"
          className="absolute left-2"
          svgClassName="h-5 w-5"
        />
        <input
          type="text"
          aria-label={placeholder || "Caută în tabel"}
          data-kt-user-table-filter="search"
          className={`${tableControlBaseClasses} w-full pl-10 pr-4`}
          placeholder={placeholder || "Cauta..."}
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>
      {/* end::Search */}
    </div>
  );
};

export default TableGlobalSearch;
